<template>
	<div
		v-if="user.permission"
	>
		<fieldset>
			<legend><img src="/bo/images/icons/user_delete.png">Privacy</legend>
			<v-btn
				color="red-lighten-2"
				@click="showAnonymizeDialog"
			>
				<translate>Anonymize the client</translate>
			</v-btn>
		</fieldset>
		<v-dialog
			v-model="anonymizeClient"
			width="500"
		>
			<v-card>
				<v-card-title>
					<translate>Are you sure you want to anonymize this client?</translate>
				</v-card-title>
				<v-card-text>
					<translate>Anonymizing will permanently remove any personal data this client has in the database and cannot be undone.</translate>
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn
						variant="text"
						color="red-darken-1"
						@click="closeCancel"
					>
						<translate>Cancel</translate>
					</v-btn>

					<form
						action="/bo/users/anonymize"
						method="post"
					>
						<input
							type="hidden"
							name="client_id"
							:value="clientId"
						>
						<v-btn
							variant="text"
							color="primary-darken-1"
							type="submit"
							@click="closeCancel"
						>
							<translate>Anonymize</translate>
						</v-btn>
					</form>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
export default {
	name: 'ClientPrivacyBox',
	props: {
		user: {
			type: Object,
			required: true,
		},
		clientId: {
			type: Number,
			required: true,
		},
	},
	data () {
		return {
			anonymizeClient: false,
		};
	},
	methods: {
		/**
		 * @returns {void}
		 */
		showAnonymizeDialog () {
			this.anonymizeClient = true;
		},

		/**
		 * @returns {void}
		 */
		closeCancel () {
			this.anonymizeClient = false;
		},
	},
};
</script>
